/**
 * @generated SignedSource<<d2580b2d3855daf3ac7a2b65fc4dc108>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReassignReviewerPopupFragment_AssignToAvatar$data = {
  readonly firstName: string;
  readonly lastName: string;
  readonly rowId: UUID;
  readonly " $fragmentType": "ReassignReviewerPopupFragment_AssignToAvatar";
};
export type ReassignReviewerPopupFragment_AssignToAvatar$key = {
  readonly " $data"?: ReassignReviewerPopupFragment_AssignToAvatar$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReassignReviewerPopupFragment_AssignToAvatar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReassignReviewerPopupFragment_AssignToAvatar",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "type": "GwtUser",
  "abstractKey": null
};

(node as any).hash = "1a15535593f31b27a13fb206661892a8";

export default node;
